"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapOrderByFromApi = void 0;
var _tsUtils = require("@ori/ts-utils");
var _constants = require("../components/BannerProductListing/constants");
/**
 * Transforms the orderBy options data from the API into a format suitable for the Sorting component.
 *
 * @param options - The orderBy options data from the API. It's a part of the ProductListingRowsFragment.
 * @returns An array of SortingMenuItem, each representing a sorting option with its key and label.
 */ const mapOrderByFromApi = (options)=>{
    var _options_filter_map;
    return (_options_filter_map = options === null || options === void 0 ? void 0 : options.filter(_tsUtils.isNonNullable).map((option)=>{
        var _option_displayText;
        return {
            key: option.orderBy,
            label: (_option_displayText = option.displayText) !== null && _option_displayText !== void 0 ? _option_displayText : _constants.DEFAULT_ORDER_BY
        };
    })) !== null && _options_filter_map !== void 0 ? _options_filter_map : [];
};
exports.mapOrderByFromApi = mapOrderByFromApi;
